import { useConfigureController } from '../hooks/useController'

import { ModalContent } from '@/components/Modal'
import { Body } from './Body'
import { Footer } from './Footer'
import { Header } from './Header'

export function Content() {
  const { ready } = useConfigureController()

  if (!ready) return null

  return (
    <ModalContent header={<Header />} footer={<Footer />} maxWidth={644}>
      <Body />
    </ModalContent>
  )
}
